import { Box } from '@mui/material';
import { formatCurrency } from '../../utils/formatMoney';
interface BlockCountedProps {
  type: 'all' | 'income' | 'expense';
  incomeData?: number[];
  expenseData?: number[];
}

export const BlockCounted: React.FC<BlockCountedProps> = ({
  type = 'all',
  incomeData = [],
  expenseData = [],
}) => {
  const incomeTotal = incomeData.reduce((sum, v) => sum + Number(v || 0), 0);
  const expenseTotal = expenseData.reduce((sum, v) => sum + Number(v || 0), 0);
  const total = incomeTotal - expenseTotal;

  let color = 'rgb(0, 0, 0)';
  if (total < 0) {
    color = 'rgb(255,0,0)';
  } else if (total > 0) {
    color = 'rgb(28,172,0)';
  }

  return (
    <Box display="flex" justifyContent="center" mt={2} mb={2}>
      <Box
        p={2}
        borderRadius={2}
        boxShadow={1}
        textAlign="center"
        sx={{ minWidth: 260, backgroundColor: 'background.paper' }}
      >
        <Box mb={1}>
          {(type === 'all' || type === 'income') && (
            <span>
              Доходы: <strong>{formatCurrency(incomeTotal, 2)}</strong>&nbsp;
            </span>
          )}

          {(type === 'all' || type === 'expense') && (
            <span>
              Расходы: <strong>{formatCurrency(expenseTotal, 2)}</strong> &nbsp;
            </span>
          )}
        </Box>
        <hr />

        <Box mt={1}>
          Итого: <span style={{ color, fontWeight: 600 }}>{formatCurrency(total, 2)}</span>
        </Box>
      </Box>
    </Box>
  );
};
